import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  Row,
  Col,
  Label,
  FormGroup,
  ModalFooter,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import ReactSelect from "react-select";
import { showInfoMessage } from "../../../../helpers/utils";
import CustomSelect from "../../../../components/Common/CustomSelect";

const ModalPositions = props => {
  const {
    isOpen,
    toggle,
    groups,
    addPosition,
    currentPositions,
    patchPositions,
    editData,
  } = props;

  const [selectedGroups, setSelectedGroups] = React.useState([]);
  const [isFormSubmit, setIsFormSubmit] = React.useState(false);

  const optionGroups = (props.groups?.results || props.groups).map(item => {
    return {
      label: item.name,
      value: item.id,
    };
  });

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      optionGroups.map(item => {
        for (let i in editData.groups) {
          if (item.value === editData.groups[i]) {
            selectedGroups.push(item);
          }
        }
      });
    } else {
      setSelectedGroups([]);
    } 
  }, [isOpen]);

  const onSubmitForm = (e, errors, params) => {
    setIsFormSubmit(true);
    if (errors?.length === 0) {
      let currentData = {
        title: params.title,
        groups: params.groups.map(item => item.value),
        description: params.description || "",
        rate: params.rate || 0,
      };

      if (props.permissions?.["change_positionmodel"]) {
        if (editData !== null) {
          patchPositions(editData.id, currentData, currentPositions);
          toggle();
        } else {
          addPosition(currentData, currentPositions);
          toggle();
        }
      } else {
        showInfoMessage("You haven't permissions");
      }
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true} toggle={toggle}>
      <AvForm className="needs-validation" onSubmit={onSubmitForm}>
        <div className="modal-header">
          <h4 className="modal-title mt-0" id="myModalLabel">
            {editData !== null ? "Edit" : "Add"} position
          </h4>
          <button
            type="button"
            onClick={toggle}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>
          <Row form>
            <Col className="col-12">
              <div className="mb-3">
                <AvField
                  name="title"
                  label="Title"
                  type="text"
                  value={editData?.title || ""}
                  placeholder="Title..."
                  validate={{
                    required: { value: true },
                    minLength: { value: 1, errorMessage: "Min 1 word" },
                    maxLength: { value: 45, errorMessage: "Max 45 words" },
                  }}
                />
              </div>
              <div className="mb-3">
                <AvField
                  name="description"
                  label="Description"
                  placeholder="Description...."
                  value={editData?.description || ""}
                  type="text"
                />
              </div>
              {/* <div className="mb-3">
                <AvField
                  name="rate"
                  label="Rate"
                  placeholder="Rate..."
                  value={editData?.rate || ""}
                  type="number"
                />
              </div> */}
              <div className="mb-3">
                <Label htmlFor="offer">Groups</Label>
                <FormGroup>
                  <CustomSelect
                    name="groups"
                    // value={selectedGroups}
                    options={optionGroups}
                    defaultValue={selectedGroups}
                    onChange={setSelectedGroups}
                    placeholder="Select group..."
                    // isMulti={true}
                    isSearchable={true}
                    classNamePrefix="select2-selection"
                    errorMessage="Groups field is required!"
                    isFormSubmit={isFormSubmit}
                    isMulti
                    required
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {props.permissions?.["change_positionmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

ModalPositions.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  addPosition: PropTypes.func.isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentPositions: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  patchPositions: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  editData: PropTypes.any,
};

export default ModalPositions;
